function readCookie(name) {
  const prefix = `${name}=`;
  const item = document.cookie
    .split(";")
    .map((v) => v.trim())
    .find((v) => v.startsWith(prefix));
  return item ? decodeURIComponent(item.slice(prefix.length)) : undefined;
}

export function trackCtaClick({ position, market, language, destination }) {
  const eventId = `cta_${crypto.randomUUID()}`;
  const payload = {
    event: "cta_partner_click",
    market,
    language,
    button_position: position,
    destination: destination || null,
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  // Browser pixel: eventID shared with server event for Meta deduplication.
  if (typeof window.fbq === "function") window.fbq("trackCustom", "cta_partner_click", payload, { eventID: eventId });
  if (window.ttq && typeof window.ttq.track === "function") window.ttq.track("cta_partner_click", payload);
  if (typeof window.gtag === "function") window.gtag("event", "cta_partner_click", payload);

  // Server-side Conversions API: fire-and-forget, never blocks navigation.
  try {
    const apiBase = process.env.REACT_APP_BACKEND_URL;
    fetch(`${apiBase}/api/meta/cta-click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_id: eventId,
        market,
        language,
        button_position: position,
        event_source_url: window.location.href,
        fbc: readCookie("_fbc"),
        fbp: readCookie("_fbp"),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {}
}
